import { mapGetters, mapMutations } from 'vuex';

export const mixins = {
  computed: {
    ...mapGetters({
      permissionsB: 'auth/permissions'
    })
  },
  methods: {
    /* ...mapMutations({      
      setOverlay: 'SET_OVERLAY'
    }), */
    $can(permissionName) {
      return this.permissionsB.map(permission => permission.name).indexOf(permissionName) !== -1;
    },
    calc(number) {
      let with4Decimals = number.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0]
      return with4Decimals;
    },
    handleError(error) {
      var message = error.response.data.message;
      var errors = error.response.data.errors;
      this.errorResponse(message, errors);
    },
    errorResponse(message, errors) {
      var n=0;
      var error = "";
      if (typeof errors == 'string') {
          error = "° " + errors;
      }
      if (typeof errors == 'object') {
          for (n in errors){
              error += "° " + errors[n]+ "\n";
          }
      }
      return swal({
          title: message,
          text: error,
          icon: 'error',
          className: 'swalError',
          buttons:{            
              cancel:{ text: "Cerrar", value: null, visible: true, closeModal: true }
          }
      });
    },
    formatDateTime(value) {
      if(!value) {
        return false;
      } 
      //var date = new Date(value.replace(/-/g, "/"));
      var date = new Date(value)
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; 
      hours = hours < 10 ? '0'+hours : hours;
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      var day = date.getDate();
      var month = date.getMonth()+1;
      var year = date.getFullYear();
      day = day < 10 ? '0'+day : day;
      month = month < 10 ? '0'+month : month;
      
      return day + "/" + month + "/" + year + "  " + strTime;
    },
    formatDate(value) {
      /* if(!value) {
        return false;
      }
      //var date = new Date(value.replace(/-/g, "/"));
      var date = new Date(value)
      var day = date.getDate();
      var month = date.getMonth()+1;
      var year = date.getFullYear();
      day = day < 10 ? '0'+day : day;
      month = month < 10 ? '0'+month : month;
      
      return day + "/" + month + "/" + year; */
     
      let date = new Date(value + 'T00:00:00');
      const options = { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit' };
      let formattedDate = date.toLocaleDateString('es-CO', options);

      return formattedDate;

    },
    generateMonths() {
      let cf = 'es-ES';      
      let months = [];
      const mot = Array.from({length: 12}, (item, i) => {       
        let month = new Date(0, i).toLocaleString(cf, {month: 'long'});
        month = month.charAt(0).toUpperCase() + month.slice(1);
        let data = {
          id: i+1,
          value: month
        };
        months.push(data);
      });
      return months;
    },
    getMonthName(value) {
      if(!value) {
        return false;
      }
      let cf = 'es-ES';
      const months = Array.from({length: 12}, (item, i) => {       
        return  new Date(0, i).toLocaleString(cf, {month: 'long'});       
      });
      let month = months[value - 1];
      month = month.charAt(0).toUpperCase() + month.slice(1);
      return month;
    },
    getYears(payroll=false, limit=null) {
      const anioActual = new Date().getFullYear();
      const anioInicio = anioActual - 9;
      let anioFin = anioActual - 1;
      if(payroll) {
        anioFin = anioActual;
      }
      const listadoAnios = [];
      for (let anio = anioInicio; anio <= anioFin; anio++) {
        listadoAnios.push(anio);
      }
  
      return limit ? listadoAnios.slice(-limit) : listadoAnios;
    },
    toCapitalize(str) {
      if (!str) return str;
      return str
      .toLowerCase()
      .split(' ')
      .map(string => string.charAt(0).toUpperCase() + string.slice(1))
      .join(' ');
    },
    formatNumber(num) {
      if (num === null || num === undefined || num === '') return '';
      let number = parseFloat(num);
      if (isNaN(number)) return num;
      return number.toLocaleString('es-ES', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
      });
    }
  },
}